export default "__VITE_ASSET__BYUsMydc__"